<template>
  <aha-modal
    size="md"
    @hide="reloadPage"
    :title="titleWelcomeback"
    class="be-taken-over-modal"
  >
    <p class="mb-2">
      {{ $i18nPresenter.t('You were gone for a while. To continue editing, please refresh.') }}
    </p>
    <template #action>
      <aha-antd-button
        v-aha-emit-action
        name="user-inactive-refresh-button"
        @click="reloadPage"
      >
        {{ $i18nPresenter.t('Refresh') }}
      </aha-antd-button>
    </template>
  </aha-modal>
</template>

<script>

export default {
  props: {
    presenter: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      titleWelcomeback: this.$i18nPresenter.t('Welcome back!'),
    }
  },
  methods: {
    reloadPage() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.be-taken-over-modal {
  ::v-deep .aha-modal-content {
    width: 28rem;
  }
}
</style>
